import React from 'react'
import styled from 'styled-components'
import palette from 'core-system/Themes/palette'
import Text from 'core-system/Text/Text'

const ContainerBox = styled.div<{ marginBottom?: string }>`
  border: 1px solid ${palette.primary.pink300};
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
`

interface SummaryContainerBoxProps {
  title?: string
  children: React.ReactNode
  titleVariant?: 'action2' | 'action3' | 'action4'
  titleMarginBottom?: string
  titleMarginTop?: string
}

const SummaryContainerBox = ({
  children,
  title,
  titleVariant = 'action2',
  titleMarginBottom = '1.5rem',
  titleMarginTop = '0.5rem',
}: SummaryContainerBoxProps) => {
  return (
    <ContainerBox marginBottom={title ? '1rem' : '0'}>
      {title && (
        <Text
          variant={titleVariant}
          fontWeight='bold'
          marginBottom={titleMarginBottom}
          marginTop={titleMarginTop}
        >
          {title}
        </Text>
      )}
      {children}
    </ContainerBox>
  )
}

export default React.memo(SummaryContainerBox)
